module.exports = __webpack_public_path__ + "static/img/classroom_img01.113cdccc.png";